"use client"

import { TypeStoreDetail } from "@/lib/redux/features/store/type"
import { useCallback, useEffect } from "react"

let initReisze: any = null
const CategoriesCRSHandlers = ({ store }: { store: TypeStoreDetail }) => {

  const getCountProductsPerRow = () => {
    let countProducts = store.grid_products
    if (window.innerWidth < 768) {
      if (countProducts > 2) {
        countProducts = 2
      }
      return countProducts
    }

    if (window.innerWidth >= 1200) {
      if (countProducts > 5) {
        countProducts = 5
      }
      return countProducts
    }

    if (window.innerWidth >= 992) {
      if (countProducts > 4) {
        countProducts = 4
      }
      return countProducts
    }

    if (window.innerWidth >= 768) {
      if (countProducts > 3) {
        countProducts = 3
      }
      return countProducts
    }

    return countProducts
  }

  const forceResizeCategorySection = () => {
    if (store.type_layout_category_section === 'by_rows') {
      const countProductsPerRow = getCountProductsPerRow()
      const rows = store.rows_per_category_section
      const maxIndex = (countProductsPerRow * rows) - 1
      const categorySections = document.querySelectorAll('.category__section--content')
      for (let i = 0; i < categorySections.length; i++) {
        const categorySection = categorySections[i];
        const productCards = categorySection.querySelectorAll('.product__list--item')
        for (let x = 0; x < productCards.length; x++) {
          const productCard: any = productCards[x];
          productCard.style.display = x > maxIndex ? 'none' : 'block'
        }
      }
    }
  }

  if (!initReisze && typeof window !== 'undefined') {
    forceResizeCategorySection()
    initReisze = true
  }

  const resizeCategorySection = useCallback(forceResizeCategorySection, [
    store.type_layout_category_section,
    store.grid_products,
    store.rows_per_category_section
  ])

  useEffect(() => {
    resizeCategorySection()
    window.addEventListener('resize', resizeCategorySection)
    return () => {
      window.removeEventListener('resize', resizeCategorySection)
    }
  }, [resizeCategorySection])

  return <></>
}

export default CategoriesCRSHandlers